import type { ReactElement } from "react";

import styles from "./Footer.module.css";

export default function FooterLinks(): ReactElement {
  return (
    <div className={styles.footerLinks}>
      <div className={styles.linksInline}>
        <span>
          <a
            href="mailto:thinkchina@sph.com.sg?ref=footer-page"
            aria-label="Contact Us via Email"
          >
            Contact Us
          </a>
          <a
            href="https://www.sph.com.sg/legal/website_tnc/?ref=footer-page"
            aria-label="View Terms & Conditions"
          >
            Terms &amp; Conditions
          </a>
        </span>
        <a
          href="https://www.sph.com.sg/tnc/pdpa?ref=footer-page"
          aria-label="View Personal Data Protection Notice"
        >
          Personal Data Protection Notice
        </a>
      </div>
    </div>
  );
}
